import { faArrowDown, faArrowUp } from "@fortawesome/pro-regular-svg-icons";

import { useGlobalCommandbarStore } from "../../store";
import { CommandbarShortcutKeys } from "../../types/common";
import CommandbarShortcutIcon from "../ShortcutIcon";

export default function Navigations() {
  const shotcutKeysPressed = useGlobalCommandbarStore(
    st => st.shotcutKeysPressed,
  );

  return (
    <div className="flex items-center gap-2">
      <CommandbarShortcutIcon
        icon={faArrowUp}
        highlight={shotcutKeysPressed[CommandbarShortcutKeys.ARROW_UP]}
      />
      <CommandbarShortcutIcon
        icon={faArrowDown}
        highlight={shotcutKeysPressed[CommandbarShortcutKeys.ARROW_DOWN]}
      />
      Navigate
    </div>
  );
}
